import axios from "axios";
import { API_URL } from "@/config";

const http = axios.create({ baseURL: API_URL, withCredentials: true });

export interface DealDocRecord {
    deal_id: number;
    deal_number: number | null;
    deal_status: string | null;
    deal_type: string | null;
    deal_locked: boolean;
    vYear: number | null;
    vMake: string | null;
    vModel: string | null;
    vVin: string | null;
    priceVehicle: string | null;
    monthlypymts: string | null;
    amountDDue: string | null;
    apr: string | null;
    term: string | null;
    deal_created_at: string;
    creditApp: {
        credit_app_fullblown_id: number;
        credit_app_locked: number | null;
        credit_app_source: string | null;
        application_created_date: string | null;
    } | null;
    buyers_order_url: string;
    insurance: {
        quote_id: number;
        coverage_type: string | null;
        premium_monthly: string | null;
        premium_annual: string | null;
        binder_number: string | null;
        binder_url: string | null;
        company: { company_name: string; phone: string | null; website: string | null };
    } | null;
    insuranceRequest: {
        request_id: number;
        status: string;
        consent_given: boolean;
        _count: { quotes: number };
    } | null;
    warranty: {
        quote_id: number;
        coverage_type: string | null;
        coverage_months: number | null;
        coverage_miles: string | null;
        monthly_cost: string | null;
        contract_number: string | null;
        contract_url: string | null;
        company: { company_name: string; phone: string | null; website: string | null };
    } | null;
    warrantyRequest: {
        request_id: number;
        status: string;
        consent_given: boolean;
        _count: { quotes: number };
    } | null;
}

export async function getMyDealDocs(): Promise<DealDocRecord[]> {
    const res = await http.get<DealDocRecord[]>("/deal-jackets/customer/mine");
    return res.data;
}

export function getBuyersOrderUrl(dealId: number): string {
    return `${API_URL}/deal-jackets/${dealId}.pdf`;
}
